const ANIMATION_END = 'animationend'

export default function onceAnimationEnds(el, name, callback) {
  el.addEventListener(ANIMATION_END, onEvent)

  function onEvent({ target, animationName }) {
    if (target === el && animationName === name) {
      el.removeEventListener(ANIMATION_END, onEvent)
      callback(el)
    }
  }
}
